import { Card, CardHeader, CardContent } from '@/components/ui/card'

export function PartyCardSkeleton() {
  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex items-start justify-between gap-2">
          <div className="flex items-center gap-2">
            <div className="bg-muted h-4 w-4 animate-pulse rounded-full" />
            <div className="bg-muted h-5 w-40 animate-pulse rounded" />
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <div className="bg-muted h-4 w-48 animate-pulse rounded" />
          <div className="bg-muted h-4 w-32 animate-pulse rounded" />
        </div>
      </CardContent>
    </Card>
  )
}
